import React, { useEffect, useState } from 'react';
import { WidgetProps } from '@rjsf/utils';
import { TextField, Autocomplete } from '@mui/material';
import { INPUT_STYLE } from '../../../../../utils/styleHelpers';
import { DetailRow } from '../../../DetailsDrawer/DetailRow';

export const StatusSelectionInput = (props: WidgetProps) => {
  const { value, onChange } = props;
  const [searchTerm, setSearchTerm] = useState(value || '');
  const [dirty, setDirty] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState<string | null>(props.value || null);
  const statusOptions = ['Active', 'Installed', 'Pending Install', 'Disconnected', 'Cancelled', 'In Progress'];

  const handleChange = (_e: React.SyntheticEvent<Element, Event>, value: string | null) => {
    setSelectedStatus(value || null);
    setSearchTerm(value || '');
    onChange(value || null);
  };

  const handleInputChange = (_e: React.SyntheticEvent<Element, Event>, value: string | null) => {
    if (!dirty) setDirty(true);
    setSelectedStatus(value || null);
    setSearchTerm(value);
    onChange(value || null);
  };

  const getHelperText = () => {
    if (isErrorState()) {
      if (props.rawErrors?.includes('must be string')) return 'Status is required';
      if (props.rawErrors?.some((e) => e.includes('must match pattern'))) {
        if (value === '' || value === undefined) return 'Status is required';
        return 'Status must be alphanumeric, please remove special characters';
      }
    }
  };

  const isErrorState = () => {
    return dirty && ((props.rawErrors && props.rawErrors.length > 0) || (!value && props.required));
  };

  useEffect(() => {
    if (value) {
      setSelectedStatus(value);
      setSearchTerm(value);
    }
  }, [value]);

  if (props.readonly) {
    if (props.formContext?.hideEmpty && !value) return null;

    return (
      <div>
        <DetailRow
          key={props.id}
          colId={props.id}
          title={props.uiSchema?.['ui:placeholder'] || ''}
          value={value}
        />
      </div>
    );
  }

  return (
    <Autocomplete
      value={selectedStatus || searchTerm}
      inputValue={searchTerm}
      onInputChange={handleInputChange}
      ListboxProps={{ style: { maxHeight: 150 } }}
      onChange={handleChange}
      onBlur={() => setDirty(true)}
      onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()}
      options={statusOptions}
      getOptionLabel={(option) => option}
      renderInput={(params) => (
        <TextField
          {...params}
          required={props.required}
          error={isErrorState()}
          helperText={getHelperText()}
          label={props.uiSchema?.['ui:placeholder']}
          InputProps={{
            ...params.InputProps,
            style: { fontSize: '.875rem' },
            name: props.uiSchema?.['ui:placeholder']
          }}
          className={INPUT_STYLE}
        />
      )}
      renderOption={(props, option) => (
        <li
          {...props}
          key={option}>
          {option}
        </li>
      )}
    />
  );
};

export default StatusSelectionInput;
